import algoliaSearchBrand from './algoliaSearchBrand'
import cleanString from '../utilities/Data/cleanString'

const getBrandSuggestions = async ({ query }) => {
	if (query && query.trim()) {
		const response = await algoliaSearchBrand(cleanString(query))
		return { suggestions: response.hits.map(brand => brand) }
	}
	return { suggestions: [] }
}

export default getBrandSuggestions



// WEBPACK FOOTER //
// ./src/dataservices/getBrandSuggestions.js